export enum UploadType {
    uploadDocumentManagementFile = 'UPLOAD_DOCUMENTMANAGEMENT_FILE',
    reuploadDocumentManagementFile = 'REUPLOAD_DOCUMENTMANAGEMENT_FILE'
}

export const uploadTypes = Object.values(UploadType) as string[]
